import {split, capitalize} from 'lodash';

export function capitalizeWords(value?: string) {
  return split(value, ' ').map(capitalize).join(' ');
}
